/*
Item: Value Dialog component for creating "Wertmerkmal" from Statistics.jsx
Name: ValueDialog
Format: Code/Frontend component
*/

import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
// import { TabView, TabPanel } from 'primereact/tabview';
import { Steps } from 'primereact/steps';
import { Growl } from 'primereact/growl';
import { InputTextarea } from 'primereact/inputtextarea';
import { ProgressSpinner } from 'primereact/progressspinner';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import valueTemplate from '../../service/data/TemplateValue.json';
import JsonHelper, { StatisticsNames } from '../../utils/statisticsUtils';

import '../../styles/valueDialog.css';
import { MultiLanguage } from '../../utils/MultiLanguage';
import { DropdownLabeled, MultiSelectLabeled } from '../DropdownLabeled';

import MessageService from '../../service/MessageService';

export default class ValueDialogRead extends Component {
  constructor(props) {
    super(props);
    this.messageService = new MessageService();
    const { closeDialogue, elements } = this.props;
    this.closeDialogue = closeDialogue;
    this.wertmerkmale = []; // elements.VALUE;
    this.subjectRegion = []; // elements.SUBJECT_CLASSIFYING;
    this.subjectRegion1 = []; // elements.REGION_CLASSIFYING;
    this.multiLanguage = new MultiLanguage();

    this.state = {
      step: 0,
      masseinheit: 'Anzahl',
      auspraegung: [],
      auspraegungen: [],
      klassifikation: [],
      selectedId: [],
      selectedClassifications: [],
      selectedExpressions: [],
      selectedData: [],
    };
  }

  handleStatisticChange(e) {
    this.setState({
      valueStatistics: e.value,
    });
    if (e.value === null) {
      this.setState({ statistiktext: '' });
    } else {
      this.setState({ statistiktext: StatisticsNames[e.value] });
    }
  }

  async handleWertmerkmalChange(e) {
    this.setState({ wertmerkmal1: e.value });
  }

  async handleKlassifikationChange(e, zeile) {
    const { klassifikation } = this.state;
    this.setState({ visible: true });
    try {
      await this.loadValuesShort(e.value, zeile);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('ERROR in handleKlassifikationChange', err);
    } finally {
      this.setState({ visible: false });
      klassifikation[zeile] = e.value;
      this.setState({ klassifikation });
    }
  }

  handleAuspraegungChange(e, zeile) {
    const { auspraegung } = this.state;
    auspraegung[zeile] = e.value;
    this.setState({ auspraegung });
  }

  handleDelete(obj) {
    const {
      selectedClassifications,
      selectedExpressions,
      selectedData,
      selectedId,
    } = this.state;
    let classification = JsonHelper.deepCopy(selectedClassifications);
    let expression = JsonHelper.deepCopy(selectedExpressions);
    let data = JsonHelper.deepCopy(selectedData);
    let id = selectedId;
    const c = obj.classification;
    for (let i = 0; i < classification.length; i += 1) { // find classification
      if (c === classification[i]) { // get index i
        if (i === 0) {
          classification.shift();
          expression.shift();
          data.shift();
          id.shift();
        } else if (i === classification.length - 1) {
          classification.pop();
          expression.pop();
          data.pop();
          id.pop();
        } else {
          // remove entry from classification, expression, and data
          classification = classification.slice(0, i).concat(
            classification.slice(i + 1, classification.length),
          );
          expression = expression.slice(0, i).concat(expression.slice(i + 1, expression.length));
          data = data.slice(0, i).concat(data.slice(i + 1, data.length));
          id = id.slice(0, i).concat(id.slice(i + 1, id.length));
        }
        this.setState({
          selectedId: id,
          selectedClassifications: classification,
          selectedExpressions: expression,
          selectedData: data,
        });
        return;
      }
    }
  }

  handleAdd(classification, expression) {
    const line = { classification: '', expression: '' };
    if (expression) {
      const { selectedId, selectedClassifications, selectedExpressions } = this.state;
      let id = 0;
      id = selectedClassifications.length;
      if (selectedId[selectedClassifications.length - 1]) {
        id = selectedId[selectedClassifications.length - 1] + 1;
      }
      let tmp = [];
      for (let i = 0; i < expression.length; i += 1) {
        tmp.push(expression[i].value);
      }
      tmp = tmp.join(' ');
      let { selectedData } = this.state;
      selectedData = JsonHelper.deepCopy(selectedData);
      if (selectedId.indexOf(classification) === -1) {
        line.classification = classification;
        line.expression = tmp;
        selectedId.push(id);
        selectedClassifications.push(classification);
        selectedExpressions.push(expression);
        selectedData.push(line);
        this.setState({
          selectedId,
          selectedClassifications,
          selectedExpressions,
          selectedData,
          auspraegung: [],
          auspraegungen: [],
          klassifikation: [],
        });
      } else {
        this.handleButton('error', 'Hinweis', 'Klassifikation wurde bereits hinzugefügt.');
      }
    } else {
      this.handleButton('error', 'Hinweis', 'Es wurde keine Ausprägung gewählt.');
    }
  }

  handleButton(severity, summary, detail) {
    this.growl.show({ severity, summary, detail });
  }

  itemTemplate = (option) => {
    // itemTemplate(option) {
    if (option) {
      return (
        `${option.value} - ${option.label}`
      );
    }
    return '';
  }

  selectedItemsTemplate = (option) => {
    // selectedItemsTemplate(option) {
    if (option) {
      return (
        `${option.value} `
      );
    }
    return '...';
  }

  async loadValuesShort(merkmaleCode, zeile) {
    const { auspraegungen, auspraegung } = this.state;
    // const deepCopy_auspraegungen = this.state.auspraegungen;
    // const deepCopy_auspraegung = this.state.auspraegung;
    // this.setState({ auspraegung: deepCopy_auspraegung });
    // this.setState({ auspraegungen: deepCopy_auspraegungen });
    if (merkmaleCode === null) {
      auspraegungen[zeile] = '';
      auspraegung[zeile] = '';
    } else {
      const isSecondOption = false;
      const type = 'valueassociation';
      const ttype = 'VARIABLE';
      const objtype = 'ASSOCIATIONVALUETOCLASSIFYINGVARIABLE';
      const elementsData = await this.messageService.postRecordStructureDirectory(merkmaleCode,
        isSecondOption, type, ttype, objtype);
      if (elementsData[1] !== 'error') {
        // map smaller
        const tmp = elementsData.map((entry) => ({
          value: entry.name,
          label: this.multiLanguage.returnInLanguage(entry, 'de'),
        }));
        auspraegungen[zeile] = tmp;
        auspraegung[zeile] = '';
        this.setState({ auspraegungen });
      }
    }
  }

  actionTemplate(tabNumber, obj) {
    return (
      <div>
        <Button
          id="delete"
          icon="pi-md-delete-forever"
          onClick={() => this.handleDelete(obj)}
          className="p-button-danger"
          tooltip="Eintrag löschen"
          tooltipOptions={{ position: 'left' }}
        />
      </div>
    );
  }

  returnTabView() {
    const {
      wertmerkmal1, valueStatistics, statistiktext, klassifikation,
      auspraegung, auspraegungen, globalFilter, selectedData, formula,
    } = this.state;
    /*
    const wertmerkmale1 = this.wertmerkmale.map((entry) => ({
      label: `${entry.name} - ${entry.inhalt}`,
      value: entry.name,
    })); */
    const tmpS = this.subjectRegion.concat(this.subjectRegion1);
    let subjectRegion = tmpS.map((entry) => ({
      label: `${entry.name} - ${entry.inhalt}`,
      value: entry.name,
    }));
    subjectRegion = subjectRegion.sort((a, b) => ((a.value > b.value) ? 1 : -1));

    const deepCopy = JsonHelper.deepCopy(valueTemplate).basismerkmal;
    const tabView = deepCopy.map((entry) => (
      <div>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-lg-12" />
          <div className="p-col-6 p-lg-6">
            <DropdownLabeled
              id="merkmal1"
              label="Zählfeld*"
              name="merkmal1"
              options={wertmerkmal1}
              value={wertmerkmal1}
              onChange={(e) => this.handleWertmerkmalChange(e)}
              showClear
            />
          </div>
          <div className="p-col-2 p-lg-2">
            <span className="p-float-label">
              <InputText disabled id="statistik1" value={valueStatistics} />
              <label htmlFor="statistik1">Statistik</label>
            </span>
          </div>
          <div className="p-col-4 p-lg-4">
            <span className="p-float-label">
              <InputText disabled id="statistik1text" value={statistiktext} />
            </span>
          </div>
          <div className="p-col-12 p-lg-12">
            <b>Klassifizierende Merkmale</b>
          </div>
          <div className="p-col-6 p-lg-6">
            <DropdownLabeled
              id="klassifikation1a"
              label="Klassifikation"
              name="klassifikation1a"
              options={subjectRegion}
              value={klassifikation[1]}
              onChange={(e) => this.handleKlassifikationChange(e, 1)}
              showClear
            />
          </div>
          <div title="BLAAAAAH" className="p-col-5 p-lg-5">
            <MultiSelectLabeled
              id="auspraegung1a"
              label="Ausprägung"
              name="auspraegung1a"
              value={auspraegung[1]}
              options={auspraegungen[1]}
              onChange={(e) => this.handleAuspraegungChange(e, 1)}
              optionLabel="name"
              itemTemplate={this.itemTemplate}
              selectedItemTemplate={this.selectedItemsTemplate}
            />
          </div>
          <div className="p-col-1 p-lg-1">
            <Button
              id="add"
              icon="pi-md-plus"
              onClick={() => this.handleAdd(klassifikation[1],
                auspraegung[1])}
              className="p-button-success"
              tooltip="Merkmal hinzufügen"
              tooltipOptions={{ position: 'left' }}
            />
          </div>
          <div className="p-col-12 p-lg-12">
            <DataTable
              emptyMessage="Bitte fügen Sie mindestens eine Klassifikation hinzu."
              stateKey={`tablestate-tab${entry.tabName}`}
              globalFilter={globalFilter}
              ref={(el) => { this.dt = el; }}
              value={selectedData}
              scrollable
              scrollHeight="154px"
            >
              <Column
                filter={false}
                style={{ width: '6em' }}
                field="classification"
                header="Klassifikation"
              />
              <Column
                filter={false}
                style={{
                  width: '20em',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                field="expression"
                header="Ausprägungen"
              />
              <Column header="Aktionen" body={(ex) => this.actionTemplate(0 + 3, ex, '')} style={{ textAlign: 'center', width: '4em' }} />
            </DataTable>
          </div>
        </div>

        <div className="p-grid p-fluid">
          <div className="p-col-12 p-lg-12">

            <b>Logische Verknüpfung der klassifizierenden Merkmale*</b>
            <br />
            Reihenfolge der klassifizierenden Merkmale beibehalten, zwischen jedem
            Klassifikationsmerkmal logische Verknüpfung eintragen. Zur Auswahl stehen: (, ), AND, OR
            <InputTextarea id="formula1" rows={1} cols={30} value={formula} onChange={(e) => this.setState({ formula: e.target.value })} autoResize />
          </div>
        </div>
      </div>
    ));
    return tabView;
  }

  isForwardDisabled(step) {
    let ret = true;
    const {
      valueStatistics, merkmalName, merkmalDescription,
      wertmerkmal1, formula, selectedClassifications,
    } = this.state;
    const checkStep0 = (valueStatistics && merkmalName && merkmalDescription);
    const checkStep1 = (wertmerkmal1 && formula && selectedClassifications.length > 0);
    if (step === 0) {
      if (checkStep0) ret = false;
    } else if (step === 1) {
      if (checkStep1) ret = false;
    }
    return ret;
  }

  returnProperties(step) {
    const { selectedStatistics } = '00000'; // this.props;
    const page = [];
    const {
      merkmalName, merkmalDescription, valueStatistics,
      statistiktext, masseinheit, formula,
    } = this.state;
    page[0] = (
      <div>
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-lg-12">
              <b>Angaben zum Wertmerkmal</b>
            </div>

            <div className="p-col-2 p-lg-2">
              <span className="p-float-label">
                <InputText maxLength="8" id="merkmalName2" value={merkmalName} onChange={(e) => this.setState({ merkmalName: e.target.value.toUpperCase() })} />
                <label htmlFor="merkmalName2">Name*</label>
              </span>
            </div>
            <div className="p-col-10 p-lg-10">
              <span className="p-float-label">
                <InputText maxLength="70" id="merkmaltext" value={merkmalDescription} onChange={(e) => this.setState({ merkmalDescription: e.target.value })} />
                <label htmlFor="merkmaltext">Beschreibung*</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-2">
              <DropdownLabeled
                showClear
                id="statistik"
                label="Statistik*"
                name="statistik"
                options={selectedStatistics}
                value={valueStatistics}
                onChange={(e) => this.handleStatisticChange(e)}
              />
            </div>
            <div className="p-col-10 p-lg-10">
              <div style={{ height: '15px' }} />
              <InputText disabled id="statistiktext2" value={statistiktext} />
            </div>
            <div className="p-col-12 p-lg-12" />
            <div className="p-col-12 p-lg-12">
              <span />
              <span className="p-float-label">
                <InputText disabled id="masseinheit" defaultValue={masseinheit} />
                <label htmlFor="masseinheit">Maßeinheit</label>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
    page[1] = (
      <div>
        &nbsp;
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-lg-12">
            <div className="card" style={{ overflow: 'scroll' }}>
              <div className="p-grid p-fluid">
                <b>Basis-Wertmerkmal für Berechnung</b>
                <div className="p-col-12 p-lg-12">
                  {this.returnTabView()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    page[2] = (
      <div>
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-lg-12">
              <b>Zusammenfassung und Speichern</b>
              <p />
              Name:
              {' '}
              {merkmalName}
              {' '}
              -
              {' '}
              {merkmalDescription}
              <br />
              Statistik:
              {' '}
              {valueStatistics}
              {' '}
              -
              {' '}
              {statistiktext}
              <br />
              Formel:
              {' '}
              {formula}
              <br />
            </div>
          </div>
        </div>
      </div>
    );

    return (page[step]);
  }

  stepsRender(severity, summary, detail) {
    this.growl.show({ severity, summary, detail });
  }

  moveInSteps(direction) {
    let { step } = this.state;
    step += direction;
    this.setState({ step });
  }

  async toggleSave() {
    const ret = await this.messageService.postVariableValueBuildRuleinit();
    const ret2 = await this.messageService.postVariableValueBuildVariableinit();
    const ret3 = await this.messageService.getCreatehelperCreatetextobject();
    const {
      valueStatistics, masseinheit, formula, selectedClassifications,
      selectedExpressions, merkmalName, merkmalDescription, wertmerkmal1,
    } = this.state;
    const basisMerkmalName = wertmerkmal1; // Korrektur, war STUD
    // const basisMerkmalName = 'STUD';
    const retData = ret3.data;
    const merkmal = JsonHelper.deepCopy(ret2.contents['genesis.container.content.GenesisTMContent'].transfermodel);
    const shortText = JsonHelper.deepCopy(retData);
    // const name = this.state.merkmalName;
    // const description = this.state.merkmalDescription;
    shortText.langText[0].text = merkmalDescription;
    merkmal.name = merkmalName;
    merkmal.shortDescription = shortText;
    const rule = JsonHelper.deepCopy(ret);
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.targetVariable = merkmalName;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.targetVariableReference = merkmal;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.statistic = valueStatistics;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.measureUnit = masseinheit;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.formula = basisMerkmalName;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.decimals = 0;

    const ret4 = await this.messageService.getVariableValueBuildCreateBaseVariable();
    const ret5 = await this.messageService.getVariableValueBuildCreateFilterobject();
    const basisMerkmal = JsonHelper.deepCopy(ret4);
    // let filterMerkmal = JsonHelper.deepCopy(ret5.data);

    basisMerkmal.baseVariable = basisMerkmalName;
    basisMerkmal.baseVariableStatistic = valueStatistics;
    basisMerkmal.baseVariableMeasureUnit = masseinheit;
    basisMerkmal.formula = formula;

    const klassifikation = selectedClassifications;
    const auspraegung = selectedExpressions;

    let filterVariableName = '';
    let filterValueName = [];

    const deepCopyBasisMerkmal = JsonHelper.deepCopy(basisMerkmal);

    const tmp4 = [];
    for (let i = 0; i < klassifikation.length; i += 1) {
      if (klassifikation[i]) {
        // Klassifikationen
        const filterMerkmal1 = JsonHelper.deepCopy(ret5);
        filterVariableName = klassifikation[i];
        filterMerkmal1.filterVariableName = filterVariableName;
        // Merkmale
        filterValueName = auspraegung[i].map((entry) => entry.value);
        filterMerkmal1.filterValueName = filterValueName;
        // basisMerkmal
        tmp4[i] = filterMerkmal1;
        // deepCopyBasisMerkmal.filterVariables[i] = filterMerkmal;
      }
      deepCopyBasisMerkmal.filterVariables = tmp4;
    }

    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.baseVariableReferences[0] = deepCopyBasisMerkmal;

    const returnMessage = await this.messageService.postVariableValueBuildInsert(rule);
    // let returnMessage = ["","error"]

    if (returnMessage[1] === 'error') {
      this.growl.show({
        life: 12000, severity: returnMessage[1], summary: 'Fehler', detail: returnMessage[0],
      });
    } else {
      this.setState({
        step: 0,
        merkmalName: '',
        merkmalDescription: '',
        valueStatistics: null,
        statistiktext: '',
        wertmerkmal1: undefined,
        auspraegung: [],
        auspraegungen: [],
        klassifikation: [],
        formula: '',
        selectedId: [],
        selectedClassifications: [],
        selectedExpressions: [],
        selectedData: [],
      });
      this.closeDialogue(true);
    }
  }

  toggleCancel() {
    this.setState({
      step: 0,
      merkmalName: '',
      merkmalDescription: '',
      valueStatistics: null,
      statistiktext: '',
      wertmerkmal1: undefined,
      auspraegung: [],
      auspraegungen: [],
      klassifikation: [],
      formula: '',
      selectedId: [],
      selectedClassifications: [],
      selectedExpressions: [],
      selectedData: [],
    });
    this.closeDialogue(false);
  }

  toggleCheck() {
    this.stepsRender('warn', 'Prüfen', 'Prüfung noch nicht implementiert');
  }

  renderFooter(step) {
    const back = <Button disabled={false} className="p-button-primary" label="Zurück" icon="pi pi-chevron-left" onClick={() => this.moveInSteps(-1)} />;
    const forward = <Button className="p-button-primary" label="Weiter" icon="pi pi-chevron-right" onClick={() => this.moveInSteps(1)} />;
    // const check = <Button disabled={false} className="p-button-info" label="Prüfen" icon="pi pi-md-playlist-add-check" onClick={() => this.toggleCheck()} />;
    const cancel = <Button className="p-button-danger" label="Abbrechen" icon="pi pi-md-clear" onClick={() => this.toggleCancel()} />;
    const ret = [];

    if (step > 0) ret.push(back);
    if (step < 3) ret.push(forward);

    return (
      <div>
        {ret}
        {cancel}
      </div>
    );
  }

  render() {
    const interactiveItems = [
      {
        label: 'Angaben',
      },
      {
        disabled: this.isForwardDisabled(0),
        label: 'Berechnung',
      },
    ];
    const { visible, step } = this.state;
    return (
      <div>
        <Growl ref={(el) => { this.growl = el; }} />
        <Dialog
          header="Lade Ausprägungen..."
          closable={false}
          closeOnEscape={false}
          visible={visible}
          modal
          onHide={() => this.setState({ visible: false })}
        >
          <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
        </Dialog>
        <Dialog
          {...this.props}
          footer={this.renderFooter(step)}
          style={{
            width: '800px',
            top: '40px',
            transform: 'unset',
            left: '400px',
          }}
        >
          <Steps
            id="wertmerkmal_bilden"
            model={interactiveItems}
            activeIndex={step}
            onSelect={(e) => this.setState({ step: e.index })}
            readOnly={false}
          />
          {this.returnProperties(step)}
        </Dialog>
      </div>
    );
  }
}
